module.exports = zebDshVendor.react;